import { logger } from '@modules/logger';
import type { CardPresetFieldAction } from '@reducers/card-preset-reducer';
import { createContext } from 'react';
import type { CardPresetFields } from 'types';

const initialContext: cardPresetContextValues = {
  allFieldTypesLocked: false,
  canLock: true,
  cardColor: undefined,
  cardFields: { fieldOrder: [] },
  cardFieldsDispatch: () => logger.warn('cardFieldsDispatch not provided for cardPresetContext'),
  saveChanges: () => logger.warn('saveChanges not provided for cardPresetContext'),
  rollbackChanges: () => logger.warn('rollbackChanges not provided for cardPresetContext'),
  queueActionOnSave: () => logger.warn('queueActionOnSave not provided for cardPresetContext'),
  lockedFields: [],
  toggleFieldLock: () => logger.warn('toggleFieldLock not provided for cardPresetContext'),
  lockedFieldTypes: [],
  toggleFieldTypeLock: () => logger.warn('toggleFieldTypeLock not provided for cardPresetContext'),
  toggleLockAllFieldTypes: () => logger.warn('toggleLockAllFieldTypes not provided for cardPresetContext'),
  colorLocked: false,
  toggleColorLock: () => logger.warn('toggleColorLock not provided for cardPresetContext'),
  qrCodeLocked: false,
  toggleQRCodeLock: () => logger.warn('toggleQRCodeLock not provided for cardPresetContext'),
  layoutImagesLocked: false,
  onFieldDelete: undefined,
  presetId: '',
  toggleLayoutImagesLocked: () => console.warn('toggleLayoutImagesLocked not provided for cardPresetContext'),
  orgId: '',
};

export interface cardPresetContextValues {
  allFieldTypesLocked: boolean;
  canLock: true;
  cardColor?: string;
  cardFields: CardPresetFields;
  cardFieldsDispatch: (action: CardPresetFieldAction) => void;
  colorLocked: boolean;
  layoutImagesLocked: boolean;
  lockedFields: string[];
  lockedFieldTypes: string[];
  presetId: string;
  qrCodeLocked: boolean;
  queueActionOnSave: (callback: () => void) => void;
  rollbackChanges: () => void;
  saveChanges: (immediate?: boolean) => void;
  toggleColorLock: () => void;
  toggleFieldLock: (id: string, toggleState?: boolean) => void;
  toggleFieldTypeLock: (id: string, toggleState?: boolean) => void;
  toggleLayoutImagesLocked: () => void;
  toggleLockAllFieldTypes: () => void;
  toggleQRCodeLock: () => void;
  orgId: string;
  /**
   * This is just for extra stuff that should happen after a field is deleted,
   * as fields can be deleted directly using the card preset reducer.
   */
  onFieldDelete?: (id: string) => void;
}

const cardPresetContext = createContext<cardPresetContextValues>(initialContext);

export { cardPresetContext };
